namespace $.$$ {
	export class $shm_hitalama_map_widget_float_chart_filter extends $.$shm_hitalama_map_widget_float_chart_filter {
		
		@ $mol_mem
		chart() {
			return this.widget().chart()!
		}

		@ $mol_mem
		traversed() {
			return this.chart().traversed()
		}
		
		field_name(): string {
			return this.widget().text()
		}

		@ $mol_mem
		filter_options(): readonly ( any )[] {
			return this.chart().filter_options( this.field_name() )
		}

		@ $mol_mem
		filter_options_checked( next?: string[] ) {
			return this.chart().filter_options_checked( this.field_name(), next )
		}
		
	}
}
